export default __webpack_public_path__ + "img/main.yellow.b06a04fc.png";